import { Injectable } from '@angular/core';

declare var Materialize: any;

@Injectable()
export class ToastService {

  constructor() { }

  showMessage(message: string, time?: number) {
    Materialize.Toast.removeAll();
    Materialize.toast(message, 4000);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/toast.service.ts